import { FETCH_VAULT_REQUEST } from 'modules/lockers/actionTypes';

import { tryParse } from 'utils/date';
import { createReducer } from 'utils/ReduxUtils';

import * as actionTypes from '../actionTypes';

const initialState = {
  date: new Date(),
  isLoading: false,
  lockerId: null,
};

const fetchPlanningSuccess = (state, { payload }) => ({
  ...state,
  date: tryParse(payload.date),
  isLoading: false,
});

const fetchPlanning = state => ({
  ...state,
  isLoading: true,
});

const fetchLockerPlanning = (state, { meta }) => ({
  ...state,
  isLoading: true,
  lockerId: meta.lockerId,
});

const fetchPlanningFailure = state => ({
  ...state,
  isLoading: false,
});

const setSelectedLockerId = (state, { payload: lockerId }) => ({
  ...state,
  lockerId,
});

export default createReducer(initialState, {
  [actionTypes.GET_LOCKER_CALENDAR]: fetchLockerPlanning,

  [FETCH_VAULT_REQUEST]: fetchPlanning,
  [actionTypes.GET_LOCKERS_CALENDAR]: fetchPlanning,

  [actionTypes.GET_LOCKER_CALENDAR_SUCCESS]: fetchPlanningSuccess,
  [actionTypes.GET_LOCKERS_CALENDAR_SUCCESS]: fetchPlanningSuccess,

  [actionTypes.GET_LOCKER_CALENDAR_ERROR]: fetchPlanningFailure,
  [actionTypes.GET_LOCKERS_CALENDAR_ERROR]: fetchPlanningFailure,

  [actionTypes.SET_SELECTED_LOCKER_ID]: setSelectedLockerId,
});
